import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Rides from './rides';
import Feed from './feed';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import LogInPage from './loginpage';
import NewRide from './newride';
import Settings from './Settings';
import Messages from './Messages';
import ProtectedRoute from './ProtectedRoute';

// Routes all of the pages that are a part of this software with their corresponding addresses
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/loginpage" element={<ProtectedRoute><LogInPage /></ProtectedRoute>} />
        <Route path="/rides" element={<ProtectedRoute><Rides /></ProtectedRoute>} />
        <Route path="/feed" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
        <Route path="/newride" element={<ProtectedRoute><NewRide /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
